<template>
  <ItemPage
    title="Sistemas de Ensino"
    size="md"
    :actions="actions"
  >
    <template
      v-if="educationSystemView"
    >
      <v-simple-table fixed-header>
        <template v-if="loading">
          <Load :loadingmsg="loadingMsg" />
        </template>
        <div
          v-else
        >
          <v-data-table
            :headers="headers"
            :items="contents"
            :items-per-page="15"
            hide-default-footer
            item-key="id"
          >
            <template #item.name="{ item }">
              <router-link :to="{ name: 'reinos.EducationSystem.educationSystemID.EducationStage', params: { educationSystemID: item.id } }">
                {{ item.name }}
              </router-link>
            </template>
            <template #item.status="{ item }">
              {{ item.status ? 'Ativo' : 'Inativo' }}
            </template>
            <template #item.created_at="{ item }">
              <v-btn
                class="mx-2"
                outlined
                small
                fab
                color="primary"
                @click="openFormEditItemDialog(item)"
              >
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
              <v-btn
                class="mx-2"
                outlined
                small
                fab
                color="primary"
                @click="confirmDelete(item)"
              >
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </template>
          </v-data-table>
        </div>
      </v-simple-table>
    </template>
    <template v-else>
      seu usuário não tem permissão
    </template>
  </ItemPage>
</template>

<script>
import Load from '@/components/Loading.vue'
import ItemPage from '@/components/pages/ItemPage.vue'
import FormAddNewItemDialog from '@/components/settings/FormAddNewItemDialog.vue'
import FormEditItemDialogWithShortName from '@/components/settings/FormEditItemDialogWithShortName.vue'

import handlesServerValidation from '@/mixins/handles-server-validation.js'

export default {
  components: {
    Load,
    ItemPage
  },

  mixins: [
    handlesServerValidation
  ],

  data () {
    return {
      educationSystemView: false,
      loading: false,
      loadingMsg: '',
      contents: [],
      headers: [
        {
          text: 'ID',
          align: 'start',
          value: 'id'
        },
        {
          text: 'Nome',
          align: 'start',
          value: 'name'
        },
        {
          text: 'Abreviatura',
          align: 'start',
          value: 'short_name'
        },
        {
          text: 'Slug',
          align: 'start',
          value: 'slug'
        },
        {
          text: 'Ordem',
          align: 'start',
          value: 'order'
        },
        {
          text: 'Status',
          align: 'start',
          value: 'status'
        },
        {
          text: 'Ações',
          align: 'start',
          value: 'created_at'
        }
      ]
    }
  },

  computed: {
    actions () {
      return [
        {
          label: 'Adicionar Sistema de ensino',
          action: this.openFormAddNewitemDIalog,
          icon: 'mdi-plus',
          disabled: !this.educationSystemView
        }
      ]
    }
  },
  created () {
    this.fetchAll()
  },
  methods: {
    fetchAll () {
      this.listEducationSystems()
      // this.educationSystemView = utils.checkPermissions('intranet-users.view-any')
      this.educationSystemView = true
    },
    async listEducationSystems () {
      this.loading = true
      this.loadingMsg = 'Carregando Lista...'
      try {
        this.contents = await this.$api.listEducationSystems()
      } catch (e) {
        this.getErrors(e)
      }
      this.loading = false
    },
    openFormAddNewitemDIalog () {
      this.$dialog.custom(FormAddNewItemDialog).with({ title: 'Sistema de Ensino', action: this.newEducationSystem }).show()
        .then((educationSystem) => {
          if (!educationSystem) {
            return false
          }
          this.listEducationSystems()
        })
    },
    openFormEditItemDialog (educationSystem) {
      this.$dialog.custom(FormEditItemDialogWithShortName).with({ title: 'Sistema de Ensino', item: educationSystem, action: this.updateEducationSystem }).show()
        .then((updatedEducationSystem) => {
          if (!updatedEducationSystem) {
            return false
          }
          this.listEducationSystems()
        })
    },
    async newEducationSystem (data) {
      await this.$api.newEducationSystem(data)
    },
    async updateEducationSystem (id, data) {
      await this.$api.updateEducationSystem(id, data)
    },
    async confirmDelete (item) {
      this.$dialog.confirm(`Apagar ${item.name}?`)
        .text('Tem certeza que deseja apagar? não será possível reverter')
        .label('Apagar')
        .onConfirm(async () => {
          await this.deleteEducationSystem(item.id)
        })
        .show()
    },
    async deleteEducationSystem (id) {
      try {
        await this.$api.deleteEducationSystem(id)
        this.$store.dispatch('setSnackBar', { text: 'Sistema de Ensino apagado com sucesso.' })
        this.listEducationSystems()
      } catch (e) {
        this.getErrors(e)
        this.$store.dispatch('setSnackBar', { text: 'Não foi possível apagar o Sistema de Ensino, tente novamente mais tarde.', color: 'red' })
      }
    }
  }
}
</script>
